import React, { useState } from 'react';

const CreateGroupModal = ({ isOpen, onClose, onCreateGroup }) => {
    const [groupName, setGroupName] = useState('');
    const [members, setMembers] = useState('');

    const handleCreate = () => {
        if (groupName.trim()) {
            const membersList = members ? members.split(',').map(m => m.trim()) : [];
            onCreateGroup(groupName, membersList);
            setGroupName('');
            setMembers('');
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className={`modal ${isOpen ? 'active' : ''}`} onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3><i className="fas fa-users" style={{ color: 'var(--group-primary)' }}></i> Создать группу</h3>
                    <button className="btn-icon" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <input 
                    type="text" 
                    placeholder="Название группы" 
                    className="message-input" 
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    style={{ width: '100%', marginBottom: '1rem' }}
                />
                <input 
                    type="text" 
                    placeholder="Пригласить участников (через запятую)" 
                    className="message-input" 
                    value={members}
                    onChange={(e) => setMembers(e.target.value)}
                    style={{ width: '100%', marginBottom: '1rem' }}
                />
                <button 
                    className="btn-primary" 
                    onClick={handleCreate}
                    style={{ width: '100%', background: 'var(--group-gradient)' }}
                >
                    <i className="fas fa-plus-circle"></i> Создать группу
                </button>
            </div>
        </div>
    );
};

export default CreateGroupModal;
